<div class="filter-bar">
  <div class="filter-bar-controls">
    <!-- LEFT group: bulk-actions toggle + icon-only filter trigger -->
    <div class="filter-bar-leading">
      @if (bulkActionsEnabled) {
        <button
          andButton
          color="default"
          size="regular"
          class="bulk-actions-control"
          [class.bulk-actions-control-active]="bulkActionsActive()"
          [attr.aria-pressed]="bulkActionsActive()"
          [dataSelector]="'cxp-crl-bulk-actions-toggle'"
          (click)="onBulkActionsToggled()"
        >
          Bulk Actions
        </button>
      }

      <button
        andButton
        color="default"
        size="regular"
        class="filter-control"
        [class.filter-control-active]="hasActiveFilters()"
        [matMenuTriggerFor]="filterMenu"
        aria-label="Filters"
        [dataSelector]="'cxp-crl-filter-control'"
      >
<!--        <aiwyn-icon name="funnel-simple" class="filter-control-icon" [height]="16" [width]="16"></aiwyn-icon>-->
        <aiwyn-icon name="funnel-simple" class="no-stroke-icon icon-color-gray-600" [height]="16" [width]="16"/>
        <!-- andButton renders its own dropdown caret for matMenuTrigger buttons; no manual chevron. -->
        @if (hasActiveFilters()) {
          <span class="filter-count-badge" aria-hidden="true">{{ activeCount() }}</span>
        }
      </button>

      <mat-menu #filterMenu="matMenu" class="crl-filter-menu">
        @for (option of filterOptions(); track option.key) {
          <button
            type="button"
            mat-menu-item
            class="filter-option"
            [dataSelector]="'cxp-crl-filter-option'"
            (click)="$event.stopPropagation(); onFilterToggled(option.key)"
          >
            <mat-checkbox
              class="filter-option-checkbox"
              [checked]="option.selected"
              (click)="$event.stopPropagation(); onFilterToggled(option.key)"
            ></mat-checkbox>
            <span class="filter-option-label">{{ option.label }}</span>
            <pill size="small" [color]="option.selected ? 'primary' : 'gray'" [value]="option.count"></pill>
          </button>
        }
      </mat-menu>
    </div>

    <!-- RIGHT group: scoped search bar — section dropdown + divider + search, one rounded container -->
    <div class="scoped-search">
      <button
        andButton
        color="ghost"
        size="regular"
        class="section-control"
        [class.section-control-active]="hasSectionScope()"
        [matMenuTriggerFor]="sectionMenu"
        [dataSelector]="'cxp-crl-section-control'"
      >
        {{ sectionTriggerLabel() }}
      </button>

      <mat-menu #sectionMenu="matMenu" class="crl-section-menu">
        @for (option of sectionOptions(); track option.id) {
          <button
            type="button"
            mat-menu-item
            class="section-option"
            [class.section-option-selected]="option.id === selectedSectionId()"
            [dataSelector]="'cxp-crl-section-option'"
            (click)="onSectionSelected(option.id)"
          >
            <span class="section-option-label">{{ option.label }}</span>
            @if (option.id === selectedSectionId()) {
              <aiwyn-icon name="check" class="section-option-check" [height]="14" [width]="14"></aiwyn-icon>
            }
          </button>
        }
      </mat-menu>

      <span class="scoped-search-divider" aria-hidden="true"></span>

      <label class="search">
        <aiwyn-icon name="search" class="search-icon" [height]="16" [width]="16"></aiwyn-icon>
        <input
          type="search"
          class="search-input"
          placeholder="Search..."
          [value]="searchQuery()"
          [dataSelector]="'cxp-crl-search'"
          (input)="onSearchInput($any($event.target).value)"
        />
      </label>
    </div>
  </div>

  @if (hasActiveFilters()) {
    <div class="active-filters">
      @for (option of activeOptions(); track option.key) {
        <button
          type="button"
          class="active-filter-chip"
          [attr.aria-label]="'Remove filter ' + option.label"
          [dataSelector]="'cxp-crl-active-filter'"
          (click)="onFilterToggled(option.key)"
        >
          <span class="active-filter-chip-label">{{ option.label }}</span>
          <aiwyn-icon name="x" [height]="12" [width]="12"></aiwyn-icon>
        </button>
      }

      <button
        type="button"
        class="clear-all"
        [dataSelector]="'cxp-crl-clear-filters'"
        (click)="clearAllFilters.emit()"
      >Clear all</button>
    </div>
  }
</div>
